export const POLL_MAX_OPTIONS = 10;
